import React, { useState } from 'react';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';
import './Download.css';

import appStoreBadge from './appstore.png';
import googlePlayBadge from './googleplay.png';
import screenshot1 from './1.png';
import screenshot2 from './2.png';
import screenshot3 from './3.png';
import screenshot4 from './4.png';

const appScreens = [
  {
    image: screenshot1,
    alt: 'Mickey Subs app menu screen',
    caption: 'Browse the menu and start an order in seconds.'
  },
  {
    image: screenshot2,
    alt: 'Mickey Subs app order tracking screen',
    caption: 'Track your order and see when pickup will be ready.'
  },
  {
    image: screenshot3,
    alt: 'Mickey Subs app rewards screen',
    caption: 'Earn coins and redeem rewards right inside the app.'
  },
  {
    image: screenshot4,
    alt: 'Mickey Subs app customization screen',
    caption: 'Customize your sub with meats, cheeses, toppings, and sauces.'
  }
];

const DownloadAppPage = () => {
  const [showNotifyPopup, setShowNotifyPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleNotifyClick = () => {
    setShowNotifyPopup(true);
  };

  const closePopup = () => {
    setShowNotifyPopup(false);
    setEmail('');
  };

  const closeSuccessPopup = () => {
    setShowSuccessPopup(false);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const handleEmailSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      await addDoc(collection(db, 'waitlist'), {
        email: email.trim().toLowerCase(),
        timestamp: serverTimestamp(),
      });

      setIsLoading(false);
      closePopup();
      setShowSuccessPopup(true);
    } catch (error) {
      console.error('Error adding to waitlist:', error);
      setIsLoading(false);
      closePopup();
      setShowErrorPopup(true);
    }
  };

  return (
    <section className="download-app">
      <h2 className="download-heading">Our Mobile App is Coming Soon!</h2>

      <p className="download-desc">
        Our mobile app is on the way. <span style={{ color: '#fff', fontWeight: 700 }}>It will be available on iPhone and Android soon</span> with rewards, offers, and quick pickup ordering.
      </p>

      <p className="download-subtitle">Coming soon for iPhone and Android.</p>

      <div className="download-stores">
        <img
          src={appStoreBadge}
          alt="Download on the App Store"
          className="store-badge"
        />

        <img
          src={googlePlayBadge}
          alt="Get it on Google Play"
          className="store-badge"
        />
      </div>

      <button className="notify-btn" onClick={handleNotifyClick}>
        Notify Me
      </button>

      <div className="download-gallery">
        <p className="download-gallery-title">A preview of what&apos;s coming in the app</p>
        <div className="download-gallery-grid">
          {appScreens.map((screen) => (
            <figure className="download-gallery-card" key={screen.alt}>
              <figcaption className="download-gallery-caption">{screen.caption}</figcaption>
              <img src={screen.image} alt={screen.alt} className="download-gallery-image" />
            </figure>
          ))}
        </div>
      </div>

      {showNotifyPopup && (
        <div className="notify-overlay" onClick={closePopup}>
          <div className="notify-card" onClick={(event) => event.stopPropagation()}>
            {!isLoading ? (
              <>
                <h3 className="notify-title">Get Notified!</h3>
                <p className="notify-message">
                  Enter your email and we&apos;ll let you know when the app launches.
                </p>
                <form onSubmit={handleEmailSubmit}>
                  <input
                    type="email"
                    className="notify-email-input"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    required
                  />
                  <div className="notify-buttons">
                    <button type="submit" className="notify-submit-btn">
                      Notify Me
                    </button>
                    <button type="button" className="notify-cancel-btn" onClick={closePopup}>
                      Cancel
                    </button>
                  </div>
                </form>
              </>
            ) : (
              <div className="loading-spinner"></div>
            )}
          </div>
        </div>
      )}

      {showSuccessPopup && (
        <div className="notify-overlay" onClick={closeSuccessPopup}>
          <div className="notify-card success-card" onClick={(event) => event.stopPropagation()}>
            <div className="success-icon">✓</div>
            <h3 className="notify-title">Thank You!</h3>
            <p className="notify-message">
              We&apos;ll notify you when the app launches.
            </p>
            <button className="notify-submit-btn" onClick={closeSuccessPopup}>
              Got it
            </button>
          </div>
        </div>
      )}

      {showErrorPopup && (
        <div className="notify-overlay" onClick={closeErrorPopup}>
          <div className="notify-card error-card" onClick={(event) => event.stopPropagation()}>
            <div className="error-icon">✗</div>
            <h3 className="notify-title">Oops!</h3>
            <p className="notify-message">
              Sorry, there was an error. Please try again.
            </p>
            <button className="notify-submit-btn" onClick={closeErrorPopup}>
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default DownloadAppPage;